import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {ENVIRONMENT, EnvironmentShared, isDev} from '@emma-labs/shared/typescript';
import {map, Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {LoggerService} from '../logger';
import {TranslationService} from '../translation/translation.service';

@Injectable({
  providedIn: 'root',
})
export class VersionUpdateService {
  private readonly url: string;

  constructor(
    private httpClient: HttpClient,
    private translation: TranslationService,
    private logger: LoggerService,
    @Inject(ENVIRONMENT) private readonly environment: EnvironmentShared,
  ) {
    this.url = isDev(this.environment.environment)
      ? `${location.origin}/version.txt`
      : `${location.origin}/${this.translation.getCurrentLanguageCode()}/version.txt`;
  }

  checkForVersionUpdate(): Observable<boolean> {
    return this.httpClient.get(`${this.url}?t=${new Date().getTime()}`, {responseType: 'text'}).pipe(
      map((currentVersion) => currentVersion.trim() !== this.environment.version),
      catchError((error) => {
        this.logger.warn('Error while trying to check version update.', {
          error,
          environmentVersion: this.environment.version,
        });
        return of(false);
      }),
    );
  }
}
